import { z } from "zod";
import { IAdminRole } from "@/services/admin-management-service";

export const adminFormSchema = z.object({
  name: z
    .string()
    .min(1, "이름을 입력해 주세요.")
    .max(50, "이름은 50자 이하로 입력해 주세요.")
    .transform((v) => v.trim()),
  email: z
    .string()
    .min(1, "이메일을 입력해 주세요.")
    .max(72, "이메일은 72자 이하로 입력해 주세요.")
    .email("유효하지 않은 형식입니다."),
  role: z.custom<IAdminRole>(),
  status: z.enum(["active", "inactive"]),
});

export type AdminFormData = z.infer<typeof adminFormSchema>;

export const adminCreateSchema = adminFormSchema;
